import { TIPO_ITENS } from 'src/utils/constants';

export const TIPO_ENTIDADE_COMENTARIO = {
  OBJETIVO_OKR: 8,
  CHAVE_RESULTADO_OKR: 9,
};

export const extractPeriodoDescricao = (item) => {
  if (!item) return null;

  if (item.descricaoPeriodo) return item.descricaoPeriodo;
  if (item.periodoDescricao) return item.periodoDescricao;
  if (item.periodo && item.ano) return `${item.periodo}/${item.ano}`;
  if (item.periodo) return item.periodo;

  return null;
};

export const buildComentarioDialogTitle = (intl, nome, periodo) => {
  return [nome, periodo].filter(Boolean).join(' - ');
};

export const getTipoEntidadeComentario = (tipoItemId) => {
  if (!tipoItemId) return null;

  switch (tipoItemId) {
    case TIPO_ITENS.INDICADOR:
      return 2; 
    case TIPO_ITENS.PARAMETRO:
      return 4; 
    case TIPO_ITENS.OBJETIVO_ESTRATEGICO:
      return 3; 
    case TIPO_ITENS.PROJETO:
      return 5; 
    default:
      return null;
  }
};


